import React, { useEffect } from 'react';
import styles from '@/styles/InvestmentAppetiteComponent.module.scss';
import { PEIHeadLine, PEISectionFooter, investmentAppetiteType } from '@/common';
import { generateRandomChar, getConditionalStatusWithPartnerStatus, getCTAS, URL } from '@/utils';
import { CardBox, CardRow } from '@/components/shared';
import { useAppContext } from '@/components';
const {
  investmentAppetiteLink: { main, route },
  basePEIURL,
} = URL;

let isECJestLocal = false;

type InvestmentAppetiteComponentProps = {
  institutionName: string;
  institutionId: string;
  userType: string;
  records: investmentAppetiteType;
};

export const InvestmentAppetiteComponent = ({
  institutionName,
  institutionId,
  records,
  userType,
}: InvestmentAppetiteComponentProps) => {
  const { region, sector, strategy } = records;
  const {
    state: { partnerStatus, isECJest },
  } = useAppContext();

  const { dispatch } = useAppContext();

  useEffect(() => {
    dispatch({
      type: 'setRecordInfo',
      payload: {
        key: 'investment-appetite',
        value: JSON.stringify(records) !== '{}',
      },
    });
  }, [dispatch, records]);

  isECJestLocal = isECJest;

  const checkInvestmentAppetite = getConditionalStatusWithPartnerStatus(
    'investment-appetite',
    partnerStatus
  );

  const allData = getCTAS(userType, institutionName, institutionId);
  const investmentAppetiteComponentData: {
    ctaHeading?: string;
    LP: string;
    GP: string;
    'LP/GP': string;
  } = allData['InvestmentAppetite'];

  const ctas = {
    ctaButton: '',
  };

  switch (partnerStatus) {
    case 'LP':
      ctas.ctaButton = investmentAppetiteComponentData.LP;
      break;
    case 'LP/GP':
      ctas.ctaButton = investmentAppetiteComponentData['LP/GP'];
      break;
  }

  return (
    <>
      {checkInvestmentAppetite ? (
        <article className={styles.container} id='investment-appetite'>
          <main className={styles['container-body']}>
            <PEIHeadLine text={`${institutionName} investment appetite`} />
            <div className={styles.investmentAppetiteContainer}>
              {strategy.name && (
                <CardBox headingText='Strategy'>
                  <InvestmentAppetiteRawItem />
                  <InvestmentAppetiteRawItem />
                  <InvestmentAppetiteActualItem record={strategy.name.replaceAll('PE - ', '')} />
                </CardBox>
              )}
              {region.name && (
                <CardBox headingText='Region'>
                  <InvestmentAppetiteActualItem record={region.name} />
                  <InvestmentAppetiteRawItem />
                  <InvestmentAppetiteRawItem />
                </CardBox>
              )}
              {sector.name && (
                <CardBox headingText='Sector'>
                  <InvestmentAppetiteRawItem />
                  <InvestmentAppetiteActualItem record={sector.name.replaceAll('PE - ', '')} />
                  <InvestmentAppetiteRawItem />
                </CardBox>
              )}
            </div>
          </main>
          <PEISectionFooter
            textToShow={investmentAppetiteComponentData.ctaHeading}
            link={ctas.ctaButton}
          />
        </article>
      ) : (
        <></>
      )}
    </>
  );
};

const InvestmentAppetiteActualItem = (props: { record: string }) => {
  return <CardRow record={props.record} iconImage={'./tick.svg'} />;
};
const InvestmentAppetiteRawItem = () => {
  const dashes = isECJestLocal ? generateRandomChar(5, 5) : generateRandomChar();
  return <CardRow record={dashes} iconImage={'./account.svg'} />;
};
